import { Pagination } from '@reveni-io/reveni-ui'

import BillingPageSkeleton from '../BillingPageSkeleton/BillingPageSkeleton'
import BillingReportsList from './BillingReportsList/BillingReportsList'
import * as Styles from './styles'

const BillingReports = ({ loadingReports, reports, page, onSelectInvoice, onChangePage }) => {
  if (loadingReports) {
    return <BillingPageSkeleton />
  }

  return (
    <>
      <Styles.InvoicesContainer>
        <BillingReportsList reports={reports?.results} onSelectInvoice={onSelectInvoice} />
      </Styles.InvoicesContainer>
      <Styles.PaginationContainer>
        <Pagination
          count={Math.ceil(reports?.count / 20)}
          page={page}
          next={reports?.next}
          previous={reports?.previous}
          onChangePage={onChangePage}
        />
      </Styles.PaginationContainer>
    </>
  )
}

export default BillingReports
